import React, { useEffect, useState } from "react";
// Componentes
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import FormMounted from "./FormMounted";

export default function ViewForm(props) {
  const { selectedForm, modalIsOpen, toggle, setStep } = props;

  // State de dados
  const [form, setForm] = useState([]);

  // State de modais
  const [confirmAlert, setConfirmAlert] = useState(false);

  // Verifica se há erros de validação; se não houver, abre o alerta de confirmação
  const handleSave = () => {
    const hasErrors = form.some((row) =>
      row.cols.some(
        (col) =>
          (col.attributes?.required && col.attributes?.errorMessage) ||
          (col.attributes?.hasValidation && col.attributes?.errorMessage) ||
          (col.attributes?.useRawErrorMessage &&
            col.attributes?.errorMessage) ||
          col.attributes?.inlineError,
      ),
    );

    // const itemsWithColumnValue = form
    //   .flatMap((row) => row.cols)
    //   .filter((col) => col.attributes?.columnValue !== undefined);

    // if (itemsWithColumnValue.length > 0) {
    //   console.log(itemsWithColumnValue);
    // } else {
    //   console.log("atributo não encontrado");
    // }

    if (!hasErrors) {
      setConfirmAlert(true);
    }
  };

  useEffect(() => {
    const raw = selectedForm?.json;
    if (!raw) return;
    try {
      const json = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (Array.isArray(json)) {
        setForm(json.filter((row) => row && Array.isArray(row.cols)));
      } else {
        // eslint-disable-next-line no-console
        console.warn("[ViewForm] json não é array:", json);
        setForm([]);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("[ViewForm] Falha ao parsear form.json:", err, raw);
      setForm([]);
    }
  }, [selectedForm?.json]);

  return (
    <div>
      {confirmAlert && (
        <SweetAlert
          success
          title="Sucesso"
          confirmBtnText="Ok"
          confirmBtnBsStyle="success"
          onConfirm={() => setConfirmAlert(false)}
        >
          Formulário enviado com sucesso!
        </SweetAlert>
      )}

      <Modal isOpen={modalIsOpen} centered size="lg">
        <ModalHeader toggle={toggle}>Visualizar</ModalHeader>
        <ModalBody>
          <FormMounted form={form} setForm={setForm} onSubmit={handleSave} />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 20,
            }}
          >
            <Button
              color="danger"
              style={{ height: 40, width: 80 }}
              onClick={toggle}
            >
              Fechar
            </Button>

            <Button
              color="primary"
              style={{ height: 40, marginLeft: 10 }}
              onClick={() => {
                setStep("_c");
                toggle();
              }}
            >
              Editar Formulário
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
